import { CommandDefinitionList } from "./commands/cmdDefinitionList.ts";
import { CommandGetDefinition } from "./commands/cmdGetDefinition.ts";
import { CommandCreateDefinition, CreateDefinitionPayload } from "./commands/cmdCreateDefinition.ts";
import { CommandSetDefinitionSegment } from "./commands/cmdSetDefinitionSegment.ts";
import { CommandUpdateDefinition, UpdateDefinitionPayload } from "./commands/cmdUpdateDefinition.ts";
import { CommandValidateConfig, ValidateConfigResponse } from "./commands/cmdValidateConfig.ts";
import { CommandListConfigVersions } from "./commands/cmdListConfigVersions.ts";

export class IngestDefinitionService {
  async fetchDefinitions(organizationId?: number) {
    return new CommandDefinitionList().run(organizationId);
  }

  async getDefinition(id: number) {
    return new CommandGetDefinition().run(id);
  }

  async createDefinition(payload: CreateDefinitionPayload) {
    return new CommandCreateDefinition().run(payload);
  }

  async setPopulationSegment(id: number, populationSegmentId: number | null) {
    return new CommandSetDefinitionSegment().run(id, populationSegmentId);
  }

  async updateDefinition(id: number, payload: UpdateDefinitionPayload) {
    return new CommandUpdateDefinition().run(id, payload);
  }

  async validateConfig(id: number): Promise<ValidateConfigResponse> {
    return new CommandValidateConfig().run(id);
  }

  async listConfigVersions(id: number) {
    return new CommandListConfigVersions().run(id);
  }
}
